import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutPage.css';

function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <button onClick={() => navigate(-1)} className="back-button">
        ← Back
      </button>
      <div className="about-content">
        <h1>About</h1>
        <p>About page coming soon...</p>
      </div>
    </div>
  );
}

export default AboutPage;

